import { Bottom } from "./Bottom";
import { Cards } from "./Cards";
import type { GameHandler, GameHandlerProps } from "../../types";
import { Heading } from "./Heading";
import { Playground } from "./Playground";
import { QUICKRANK_ROOT_ID } from "../../constants";
import { QuickRankContextProvider } from "../../contexts/quickrank";
import { RatingModal } from "./RatingModal";

import styles from "./QuickRankGame.module.scss";

export const QuickRankGame: GameHandler = ({ game, finishGame }: GameHandlerProps) => {
  return (
    <QuickRankContextProvider game={game} onGameFinished={finishGame}>
      <div className={styles.quickRankGame} id={QUICKRANK_ROOT_ID}>
        <Cards />
        <Heading />
        <Playground />
        <Bottom />
        <RatingModal />
        {/* <CardPreview /> */}
        {/* <PreviewModal /> */}
      </div>
    </QuickRankContextProvider>
  );
};
